import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import api from "@/api";
import { useLang } from "@/i18n";

function Shell({ children }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0d3a1e] px-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-10 text-center shadow-2xl animate-fade-up">{children}</div>
    </div>
  );
}

export function PaymentSuccess() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("processing");
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) { setStatus("failed"); return; }
    const poll = async () => {
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") { setStatus("paid"); return; }
      } catch { /* keep polling */ }
      attempts.current += 1;
      if (attempts.current < 15) setTimeout(poll, 2000);
      else setStatus("failed");
    };
    poll();
  }, [sessionId]);

  return (
    <Shell>
      {status === "paid" ? (
        <>
          <CheckCircle2 className="mx-auto mb-4 text-[#84CC16]" size={56} />
          <h1 className="font-['Outfit'] text-2xl font-bold text-[#165A2E]" data-testid="payment-success-title">{t("paymentSuccess")}</h1>
        </>
      ) : status === "failed" ? (
        <>
          <XCircle className="mx-auto mb-4 text-red-500" size={56} />
          <h1 className="font-['Outfit'] text-2xl font-bold text-red-600" data-testid="payment-failed-title">{t("paymentCancelled")}</h1>
        </>
      ) : (
        <>
          <Loader2 className="mx-auto mb-4 animate-spin text-[#165A2E]" size={48} />
          <p className="text-slate-600" data-testid="payment-processing">{t("paymentProcessing")}</p>
        </>
      )}
      <Link to="/app/finance" data-testid="back-to-finance" className="gfa-btn-primary mt-8 inline-block text-sm">{t("backToFinance")}</Link>
    </Shell>
  );
}

export function PaymentCancel() {
  const { t } = useLang();
  return (
    <Shell>
      <XCircle className="mx-auto mb-4 text-amber-500" size={56} />
      <h1 className="font-['Outfit'] text-2xl font-bold text-slate-800" data-testid="payment-cancel-title">{t("paymentCancelled")}</h1>
      <Link to="/app/finance" data-testid="cancel-back-to-finance" className="gfa-btn-primary mt-8 inline-block text-sm">{t("backToFinance")}</Link>
    </Shell>
  );
}

export function PaymentResult() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const ok = params.get("status_id") === "1";
  return (
    <Shell>
      {ok ? (
        <>
          <CheckCircle2 className="mx-auto mb-4 text-[#84CC16]" size={56} />
          <h1 className="font-['Outfit'] text-2xl font-bold text-[#165A2E]" data-testid="toyyib-success-title">{t("paymentSuccess")}</h1>
        </>
      ) : (
        <>
          <XCircle className="mx-auto mb-4 text-red-500" size={56} />
          <h1 className="font-['Outfit'] text-2xl font-bold text-red-600" data-testid="toyyib-failed-title">{t("paymentCancelled")}</h1>
        </>
      )}
      <Link to="/app/finance" data-testid="result-back-to-finance" className="gfa-btn-primary mt-8 inline-block text-sm">{t("backToFinance")}</Link>
    </Shell>
  );
}
